
import urlbase from './baseIp.js';
const URL = urlbase;
const prefix = URL + '/wms/'
const prefix1 =URL +  '/wanhua/'
const prefix2 = URL +'/fee/'
const prefix3 = URL +'/wanhua/'
const prefix4 = URL +'/image/'
const prefix5 = URL +'/sampleLog/'
const prefix6 = URL+'/sample/'
// /sample/insSample
const url = {
    // 注册
    getOutAccept: prefix + 'getOutAccept',
    getInAccept: prefix + 'getInAccept',
    pushCKTask:prefix + 'pushCKTask',
    pushTask:prefix + 'pushTask',
    finishTask:prefix1 + 'finishTask',
    insErp:prefix+'insErp',
    getFee:prefix2+'getFee',
    getClient:prefix2+'getClient',
    getBatchNo:prefix1+'getBatchNo',
    minusOne:prefix1+'minusOne',
    getPaths:prefix4+'getPaths',
    getLogList:prefix5 + 'getLogList',
    getListBy:prefix6 + 'getListBy',
    getElementByCode:prefix6 + 'getElementByCode',
    modify:prefix6 + 'modify',
    getUnitByName:prefix6 + 'getUnitByName',
    readFile:prefix6 + 'readFile',
    insSample:prefix6 + 'insSample',
}
export default url